import React from 'react';
import './Dashboard.css';

const GoogleDocThumbnail = ({ document, isSelected, onClick, onDelete }) => {
  const getFileIcon = (filename) => {
    if (filename.toLowerCase().includes('pdf')) return '📄';
    if (filename.toLowerCase().includes('doc')) return '📝';
    if (filename.toLowerCase().includes('ppt')) return '📊';
    return '📄';
  };

  const getFileColor = (filename) => {
    if (filename.toLowerCase().includes('pdf')) return '#ff4444';
    if (filename.toLowerCase().includes('doc')) return '#4285f4';
    if (filename.toLowerCase().includes('ppt')) return '#ff9800';
    return '#666666';
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return date.toLocaleDateString();
  };

  return (
    <div 
      className={`google-doc-thumbnail ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
    >
      {/* Document Preview */}
      <div className="doc-preview">
        <div className="doc-page">
          <div className="doc-header" style={{ backgroundColor: getFileColor(document.filename) }}>
            <span className="doc-icon">{getFileIcon(document.filename)}</span>
          </div>
          <div className="doc-content">
            <div className="doc-lines">
              <div className="doc-line"></div>
              <div className="doc-line short"></div>
              <div className="doc-line"></div>
              <div className="doc-line medium"></div>
              <div className="doc-line short"></div>
            </div>
          </div>
        </div>
        
        {/* Selection Indicator */}
        {isSelected && (
          <div className="selection-indicator">
            <div className="checkmark">✓</div>
          </div>
        )}
      </div>

      {/* Document Info */}
      <div className="doc-info">
        <h3 className="doc-title" title={document.document_name}>
          {document.document_name}
        </h3>
        <div className="doc-meta">
          <span className="doc-date">{formatDate(document.upload_date)}</span>
          <span className="doc-size">{formatFileSize(document.file_size)}</span>
        </div>
        <div className="doc-stats">
          <span className="doc-chunks">{document.chunk_count} chunks</span>
          <span className="doc-status">Ready</span>
        </div>
      </div>

      {/* Action Menu */}
      <div className="doc-actions" onClick={(e) => e.stopPropagation()}>
        <button 
          className="action-btn delete-btn"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(document.id);
          }}
          title="Delete document"
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

export default GoogleDocThumbnail;
